// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import taskDependencyEntity from './entities/task-dependency.json';
import taskDependencyMenu from '../pages/task-dependency/menu.json';
import taskDependencyFullForm from '../pages/task-dependency/forms/full.json';
import taskDependencyContextForm from '../pages/task-dependency/forms/context.json';
import taskDependencyMiniForm from '../pages/task-dependency/forms/mini.json';
import taskDependencyLookupForm from '../pages/task-dependency/forms/lookup.json';
import taskDependencyTableView from '../pages/task-dependency/views/table.json';
import taskDependencyCardsView from '../pages/task-dependency/views/cards.json';
import taskDependencyDashboardView from '../pages/task-dependency/views/dashboard.json';

/** Тип запису «Залежність завдання» зі сторінками пакета: меню, форми та подання з pages/task-dependency/. */
export const taskDependencyDefinition: IRecordTypeDefinition = {
  ...taskDependencyEntity,
  views: assembleViewSet({
      table: taskDependencyTableView,
      cards: taskDependencyCardsView,
      dashboard: taskDependencyDashboardView,
  }),
  form: taskDependencyFullForm,
  forms: { full: taskDependencyFullForm, context: taskDependencyContextForm, mini: taskDependencyMiniForm, lookup: taskDependencyLookupForm },
  menu: taskDependencyMenu,
} as IRecordTypeDefinition;
